import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {useApplicationAccounts} from "../hooks/useApplicationAccounts.ts";
import {useParams} from "react-router-dom";

export const IndexPage = () => {

    const {id: applicationId} = useParams()
    if (!applicationId) {
        throw new Error('applicationId is required parameter')
    }

    const {
        visibleItems,
    } = useApplicationAccounts(applicationId);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable records={visibleItems}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
